import {
  NgModule,
  Injector,
  DoBootstrap,
  CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginAndRegisterWidgetComponent } from './login-and-register-widget/login-and-register-widget.component';
import { createCustomElement } from '@angular/elements';
import { PreLoginViewComponent } from './login-and-register-widget/pre-login-view/pre-login-view.component';
import { PostLoginViewComponent } from './login-and-register-widget/post-login-view/post-login-view.component';
import { DropDownModalComponent } from './login-and-register-widget/post-login-view/drop-down-modal/drop-down-modal.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { ConsumerProfileComponent } from './consumer-profile/consumer-profile.component';
import { MyProfileComponent } from './consumer-profile/my-profile/my-profile.component';
import { ApplicationStatusListingComponent } from './consumer-profile/application-status-listing/application-status-listing.component';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { SubmittedApplicationListingComponent } from './consumer-profile/submitted-application-listing/submitted-application-listing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { PtlAccountManagementModule } from '@ptl/account-management';
import { PtlXhrModule } from '@ptl/xhr';
import { StateModule } from '@ptl/state';
import { ReducersRegistryModule } from 'src/app/shared/modules/reducers-registry.module';
import { PtlGlobalComponentsModule } from '@ptl/global-components';
import { UserInfoService } from '../shared/services/user-info.service';
import { AgentInformationComponent } from './consumer-profile/agent-information/agent-information.component';
import { environment } from 'src/environments/environment';
import { NpnAndFFMChangeModalComponent } from './consumer-profile/agent-information/npn-and-ffmchange-modal/npn-and-ffmchange-modal.component';
import { NoSuperAgencyForInternalUser } from './consumer-profile/agent-information/pipes/no-super-agency-for-internal-user.pipe';

@NgModule({
    declarations: [
        LoginAndRegisterWidgetComponent,
        PreLoginViewComponent,
        PostLoginViewComponent,
        DropDownModalComponent,
        ConsumerProfileComponent,
        MyProfileComponent,
        ApplicationStatusListingComponent,
        SubmittedApplicationListingComponent,
        AgentInformationComponent,
        NpnAndFFMChangeModalComponent,
        NoSuperAgencyForInternalUser
    ],
    imports: [
        CommonModule,
        OverlayModule,
        MaterialGlobalModule,
        PtlAccountManagementModule.forRoot(environment),
        PtlXhrModule,
        StateModule,
        ReducersRegistryModule,
        PtlGlobalComponentsModule,
        FormsModule,
        ReactiveFormsModule
    ],
    providers: [CookieService, UserInfoService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserProfileModule implements DoBootstrap {
  constructor(private injector: Injector) {
    this.createElementIfDoesNotExist(
      'sxe-login-and-register-widget',
      LoginAndRegisterWidgetComponent
    );
    this.createElementIfDoesNotExist(
      'sxe-consumer-profile',
      ConsumerProfileComponent
    );
  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, {
        injector: this.injector
      });
      customElements.define(elementName, customElement);
    }
  }

  // https://github.com/angular/angular/issues/31135
  // Necessary to not get errors associated w/ attachShadow to Angular Element
  ngDoBootstrap() { }
}
